module.exports = __webpack_public_path__ + "static/media/canyon-group.802013b3.jpg";